import { styled } from "@pigment-css/react";
import type { Kpi } from "@acto/genui-components-schema";
import { FooterCol, KpiValue, MetaLabel, SubLabel } from "@acto/taskpane/field-sales-2/components/primitives/Card";

const Figures = styled("dl")(({ theme }) => ({
  margin: 0,
  paddingTop: theme.fieldSalesTwo.spacing[8],
  display: "grid",
  gridTemplateColumns: `repeat(auto-fit, minmax(calc(50% - ${theme.fieldSalesTwo.spacing[8]}), 1fr))`,
  columnGap: theme.fieldSalesTwo.spacing[16],
  rowGap: theme.fieldSalesTwo.spacing[24],
}));

const Figure = styled(FooterCol)({ margin: 0 });

const Value = styled(KpiValue)({
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

const ValueGroup = styled("dd")(({ theme }) => ({
  margin: 0,
  display: "flex",
  flexDirection: "column",
  gap: theme.fieldSalesTwo.spacing[4],
  minWidth: 0,
}));

const Detail = styled(SubLabel)(({ theme }) => ({
  color: theme.fieldSalesTwo.colors.neutral[800],
}));

export function KpiPair({ items }: { items: Kpi[] }) {
  return (
    <Figures>
      {items.map((kpi) => (
        <Figure key={kpi.label}>
          <MetaLabel as="dt">{kpi.label}</MetaLabel>
          <ValueGroup>
            <Value>{kpi.value}</Value>
            {kpi.detail && <Detail>{kpi.detail}</Detail>}
          </ValueGroup>
        </Figure>
      ))}
    </Figures>
  );
}
